/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_D3dInputs */

const en_mk_sol_operasional_d3d = /** @type {(inputs: Mk_Sol_Operasional_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent flags what looks wrong and raises an approval; it never decides anything outbound on its own.`)
};

const id_mk_sol_operasional_d3d = /** @type {(inputs: Mk_Sol_Operasional_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen menandai yang tidak wajar dan mengajukan approval; ia tidak pernah memutuskan sendiri hal yang berdampak keluar.`)
};

/**
* | output |
* | --- |
* | "The agent flags what looks wrong and raises an approval; it never decides anything outbound on its own." |
*
* @param {Mk_Sol_Operasional_D3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_d3d = /** @type {((inputs?: Mk_Sol_Operasional_D3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_D3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_d3d(inputs)
	return en_mk_sol_operasional_d3d(inputs)
});